module.exports = __webpack_public_path__ + "static/img/SA.1a2a19ef.svg";